import React from "react";
import styled, { withTheme } from "styled-components";
import moment from "moment";
import SecondaryButton from "../../../ui-library/Buttons/SecondaryButton/SecondaryButton";
import PrimaryButton from "../../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import MacronutrientsTotal from "../../MacronutrientsTotal/MacronutrientsTotal";
import { DateFormat } from "../../../../modules/constants";
import { useTranslation } from "react-i18next";

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  p {
    margin-bottom: 20px;
    & + div {
      margin-bottom: 0px;
    }
  }
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const TotalsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const FastingDayWrapper = styled.span`
  color: ${(props) => props?.theme?.chiliRed};
`;

const DailySummary = (props) => {
  const {
    isFastingDayConfirmation,
    completeDayData,
    finishDay,
    closeModal,
    totalsData,
    isModal,
  } = props;

  const { t } = useTranslation();

  return (
    <ComponentWrapper data-testid="day-summary">
      <p>
        {t("contentText.dietDiary.completeDay.message", {
          date: moment(completeDayData.day).format(DateFormat.EXTENDED_FORMAT),
        })}
      </p>
      {totalsData && (
        <TotalsWrapper>
          <MacronutrientsTotal
            {...totalsData}
            isFastingDay={isFastingDayConfirmation}
            isModal={isModal}
          />
        </TotalsWrapper>
      )}

      {isFastingDayConfirmation ? (
        <p>
          <FastingDayWrapper>
            {t("appText.dietDiary.completeDayFasting.confirmation")}
          </FastingDayWrapper>
        </p>
      ) : (
        <p>{t("contentText.dietDiary.completeDay.confirmation")}</p>
      )}
      <ActionButtonsContainer>
        <SecondaryButton
          data-testid="day-summary-cancel-button"
          className="mr-2"
          size={"sm"}
          onClick={closeModal}
        >
          {t("appText.cancel")}
        </SecondaryButton>
        <PrimaryButton
          data-testid="day-summary-confirm-button"
          size={"sm"}
          onClick={finishDay}
        >
          {t("appText.confirm")}
        </PrimaryButton>
      </ActionButtonsContainer>
    </ComponentWrapper>
  );
};
export default withTheme(DailySummary);
